import { request } from '@/utils';

//{{apiHost}}/sign-sdk/contracts/ES-jacp4rHL0ztVQ2VZZo8xu
export const getContractByApiKey = async (id: string, apiKey: string): Promise<any> => {
  return request({
    url: `/sign-sdk/contracts/detail`,
    method: 'POST',
    data: {
      contractId: id,
      accessCode: apiKey
    }
  });
};
